import { ViewOption } from '@/lib/types';

export const BLOG_LABEL = 'Blog';
export const UNCATEGORIZED_LABEL = 'Uncategorized';

export const IS_PRODUCTION = process.env.NEXT_PUBLIC_APP_ENV === 'prod';
export const IS_DEVELOPMENT = process.env.NEXT_PUBLIC_APP_ENV === 'dev';

export const viewOptions: ViewOption[] = [
	{
		value: 'Schedule',
		label: 'Schedule'
	},
	{
		value: 'Week',
		label: 'Week'
	}
] as const;

export const MATCH_ACTIONS = [
	{
		value: '2',
		label: 'Home team-WD'
	},
	{
		value: '3',
		label: 'Away team-WD'
	},
	{
		value: '4',
		label: 'Cancel'
	}
] as const;

export const MATCH_MODE = {
	Lineup: 'Lineup',
	Scores: 'Scores',
	Final: 'Final'
} as const;

export const MATCH_RETIRE_ACTIONS = {
	RETIRE: 'Retire',
	FORFEIT: 'Forfeit',
	UNDO_RETIRE: 'Undo Retire',
	UNDO_FORFEIT: 'Undo Forfeit'
} as const;

export const MATCH_RETIRE_OPTIONS: ViewOption[] = [
	{
		value: MATCH_RETIRE_ACTIONS.RETIRE,
		label: MATCH_RETIRE_ACTIONS.RETIRE
	},
	{
		value: MATCH_RETIRE_ACTIONS.FORFEIT,
		label: MATCH_RETIRE_ACTIONS.FORFEIT
	}
] as const;

export const GAME_NUMBERS = {
	G1: 'G1',
	G2: 'G2',
	G3: 'G3',
	G4: 'G4',
	G5: 'G5',
	FINAL: 'Final'
} as const;

export const GAME_NUMBER_TO_INDEX: Record<string, number> = {
	[GAME_NUMBERS.G1]: 0,
	[GAME_NUMBERS.G2]: 1,
	[GAME_NUMBERS.G3]: 2,
	[GAME_NUMBERS.G4]: 3,
	[GAME_NUMBERS.G5]: 4,
	[GAME_NUMBERS.FINAL]: 5
} as const;

export const GAME_INPUTS = [
	{
		gameNumber: GAME_NUMBERS.G1
	},
	{
		gameNumber: GAME_NUMBERS.G2
	},
	{
		gameNumber: GAME_NUMBERS.G3
	},
	{
		gameNumber: GAME_NUMBERS.G4
	},
	{
		gameNumber: GAME_NUMBERS.G5
	},
	{
		gameNumber: GAME_NUMBERS.FINAL
	}
] as const;

export const MATCHUP_MODAL_TYPE = {
	WITHDRAW: 'withdraw',
	CANCEL: 'cancel'
} as const;

export const subStepContent: Record<number, { title: string; description: string }> = {
	1: {
		title: 'Player to be subbed out',
		description: 'Please select the player who is leaving the game.'
	},
	2: {
		title: 'Player to be subbed in',
		description: 'Please search and select the player who is entering the game as a replacement.'
	},
	3: {
		title: 'Select Matches & Games',
		description: 'Select all the matches and games you are subbing the player.'
	},
	4: {
		title: 'Confirm substitution',
		description: 'Please check if everything seems correct.'
	}
};

export const subSidebarTitleAndSubtitle: Record<number, { title: string; description: string }> = {
	1: {
		title: 'Players from your team',
		description: 'Select the player who is entering the game as a replacement.'
	},
	2: {
		title: 'Players from sub list',
		description: 'Select the player who is entering the game as a replacement.'
	},
	3: {
		title: 'Search all players in Pickleball.com',
		description: 'Please search and select the player who is entering the game as a replacement.'
	}
};

export const GAME_SCORE_MAX = 99;
